import { Component } from '@angular/core';
import { GlobalAdjustments } from '../models/global-adjustments.model';
import { GlobalSettings } from '../models/global-settings.model';
import { OutputColumn } from '../models/output-columns.model';
import { GlobalSettingsService } from '../services/global-settings.service';

@Component({
    templateUrl: './settings-output-options.component.html',
    styleUrls: [ './settings-output-options.component.scss' ]
})

export class OutputSettingsComponent {
    settings: GlobalSettings;
    displayColumnSettings: Array<OutputColumn>;
    allSelected = false;

    constructor(private settingsService: GlobalSettingsService) {
        this.settingsService.onGlobalSettingsUpdated.subscribe(
            (response) => {
                this.settings = response;
                this.displayColumnSettings = response.outputColumns;
                this.allSelected =
                    this.displayColumnSettings.filter(column => column.selected).length === this.displayColumnSettings.length;
            },
            (error) => console.log(error)
        );

        this.settingsService.getGlobalAdjustments();
    }

    updateGlobalAdjustments() {
        this.settingsService.updateGlobalAdjustments(this.settings);
    }

    toggleColumns() {
        this.allSelected = !this.allSelected;
        for (const column of this.displayColumnSettings) {
            column.selected = this.allSelected;
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/settings/components/settings-output-options.component.ts